export default { values: { xs: 0, sm: 500, md: 1023, lg: 1280, xl: 1920, xxl: 2560 } };